import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertAdditionalColorOptions } from './expert-additional-color.component';

@Directive({
  selector: '[addColorPlaceholderNullOnClick]'
})

export class AddColorPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertAddOptions : ExpertAdditionalColorOptions) {
    }

    @Output()
    public addColorPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.expertAddOptions.expertAddColorOptions="";
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color-placeholder-null.ts